import './UserControls.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { adminActions } from '@sonar-software/sonar-admin';
import { Button } from 'antd';
import { createAsyncSelectors } from '@lib/selectors';
import Icon from '@ant-design/icons';
import incognitoIcon from 'images/incognito.svg';
import { useNavigate } from 'react-router-dom';
import React, { useCallback, useEffect } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const impersonatedUserTokensSelectors = createAsyncSelectors((state) => state.admin.authentication.impersonatedUserTokens.get);
export const ImpersonateUserButton = (props) => {
    const navigate = useNavigate();
    const { userId, userIsLocked, shardName } = props;
    const impersonatedUserToken = useSonarSelector(impersonatedUserTokensSelectors.data);
    const impersonatedUserTokenIsRequested = useSonarSelector(impersonatedUserTokensSelectors.isRequested);
    const getImpersonatedUserToken = useAction(adminActions.requestGetAdminAuthenticationImpersonatedUserToken);
    const handleImpersonateUserClicked = useCallback(() => {
        getImpersonatedUserToken({
            shardName,
            userId
        });
    }, [getImpersonatedUserToken, userId, shardName]);
    useEffect(() => {
        if (impersonatedUserToken) {
            navigate(`/token/${impersonatedUserToken.token}`, { replace: true });
        }
    }, [impersonatedUserToken, navigate]);
    return (React.createElement(Button, { className: 'impersonate-user-button', disabled: userIsLocked, icon: React.createElement(Icon, { component: () => React.createElement("img", { src: incognitoIcon }) }), loading: impersonatedUserTokenIsRequested, onClick: handleImpersonateUserClicked }, ADMIN_DASHBOARD_COPY.IMPERSONATE));
};
